import { logger } from './logger';
import { LogCategory } from "@/logging/types";

let isRegistered = false

function buildContext(extra = {}) {
    return {
        online: navigator.onLine,
        visibilityState: document.visibilityState,
        pathname: globalThis.location.pathname,
        referrer: document.referrer || null,
        ...extra,
    }
}

export function initLifecycleLogging() {
    if (isRegistered) return
    isRegistered = true

    logger.info(
        LogCategory.APP_LIFECYCLE,
        'app.startup',
        buildContext(),
        'App startup detected',
    ).then()

    const onOnline = () => {
        logger.info(
            LogCategory.APP_LIFECYCLE,
            'connectivity.changed',
            buildContext({ status: 'online' }),
            'Connectivity changed',
        ).then()
    }

    const onOffline = () => {
        logger.warn(
            LogCategory.APP_LIFECYCLE,
            'connectivity.changed',
            buildContext({ status: 'offline' }),
            'Connectivity changed',
        ).then()
    }

    const onVisibilityChange = () => {
        if (document.visibilityState === 'visible') {
            logger.info(
                LogCategory.APP_LIFECYCLE,
                'app.resume',
                buildContext({ trigger: 'visibilitychange' }),
                'App resumed',
            ).then()
        }
    }

    const onPageShow = (event) => {
        if (event.persisted) {
            logger.info(
                LogCategory.APP_LIFECYCLE,
                'app.resume',
                buildContext({ trigger: 'pageshow', persisted: true }),
                'App restored from page cache',
            ).then()
        }
    }

    globalThis.addEventListener('online', onOnline)
    globalThis.addEventListener('offline', onOffline)
    document.addEventListener('visibilitychange', onVisibilityChange)
    globalThis.addEventListener('pageshow', onPageShow)

    globalThis.addEventListener('error', (event) => {
        logger.error(
            LogCategory.APP_LIFECYCLE,
            'error.unhandled',
            buildContext({
                message: event.message,
                filename: event.filename,
                line: event.lineno,
                column: event.colno,
            }),
            'Unhandled runtime error',
        ).then()
    })

    globalThis.addEventListener('unhandledrejection', (event) => {
        const reason = event.reason?.message ? event.reason.message : String(event.reason)
        logger.error(
            LogCategory.APP_LIFECYCLE,
            'error.unhandled.rejection',
            buildContext({ reason }),
            'Unhandled promise rejection',
        ).then()
    })
}


